import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const priceService = {
  async getForPrint(categoryId: number, summaryId: string): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_PAYMENT_PRICE
          .replace(':categoryId', String(categoryId))
          .replace(':summaryId', '' + summaryId),
          config
      );
      return data;
    } catch (e) {
      throw new Error(e);
    }
  },
  async getForOpportunity(uniqueId: string): Promise<any> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_PRICE_OPPORTUNITY_WEB
          .replace(':uniqueId', '' + uniqueId)
      );
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
}
